import {
  snakeCase2camelCase,
  formateObjKeys,
  goodsInit,
} from '@didi/trade-sdk/lib/quartz-mall'
import { request } from '../api'
import { GlobalConfig } from '../config'
import { GlobalEnv } from '../global_env'
import { URLQueries } from '../global_env/url_query'

export const getDoingGoodsInfo = async id => {
  const params = {
    group_id: URLQueries.getQuery('groupId'),
    token: GlobalEnv.loginInfo.token,
    source_id: GlobalEnv.channelId,
    lat: GlobalEnv.locationInfo.lat,
    lng: GlobalEnv.locationInfo.lng,
    order_id: id,
  }
  const res = await request.post(GlobalConfig.APIs.goodsProcessInfo, params, {
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
  const { goods_info, group_info, order_info, pop, cashback } = res
  const goods = await goodsInit(goods_info)
  const group = formateObjKeys(group_info, snakeCase2camelCase)
  const order = formateObjKeys(order_info, snakeCase2camelCase)
  const popRes = formateObjKeys(pop, snakeCase2camelCase)
  return {
    goods: goods.goodsData,
    goodsInstance: goods,
    group,
    order,
    pop: popRes,
    cashback,
  }
}

// 本次发团失败时直接再次开团，因此不需要此轮询
let timeLength = 0
export const getGroupRolling = async (group, order) => {
  const params = {
    group_id: group.groupId,
    token: GlobalEnv.loginInfo.token,
    order_id: order || URLQueries.getQuery('orderId'),
  }
  const data = await request.get(GlobalConfig.APIs.groupRolling, params)
  const _data = formateObjKeys(data, snakeCase2camelCase)
  if (_data.flag === 0 && _data.failType === 0) {
    if (timeLength <= 10) {
      setTimeout(() => {
        getGroupRolling(group, order)
      }, 1000)
    }
    timeLength++
  }
  return _data
}
